import Text from '../../../atoms/Text';

import './styles.scss';

export type TableFilterOption = {
  label: string;
  value: string;
};

export type TableFilterSelect = (value?: string) => void;

interface ITableFilterProps {
  options: TableFilterOption[];
  selected?: string | null;
  title?: string;
  onSelect: TableFilterSelect;
}

const TableFilter = ({
  options,
  selected,
  title,
  onSelect,
}: ITableFilterProps) => {
  return (
    <div className='table_filter'>
      {title && (
        <Text size={14} className='table_filter__option'>
          {title}
        </Text>
      )}
      {options.map((option) => (
        <Text
          key={option.value}
          size={14}
          className={`table_filter__option ${
            option.value === selected ? 'table_filter__option--selected' : ''
          }`}
          onClick={() =>
            onSelect(option.value === selected ? undefined : option.value)
          }
        >
          {option.label}
        </Text>
      ))}
    </div>
  );
};

export default TableFilter;
